import React from 'react';
import { Menu } from 'lucide-react';
import { useAuth } from '../../AuthContext'; // Ajusta la ruta

// Acepta 'trigger' como prop
const Header = ({ sidebarOpen, setSidebarOpen, trigger }) => {
  const { user, userData, userType } = useAuth();

  // --- LÓGICA PARA OBTENER EL LOGO DEL COLEGIO ---
  let schoolLogoUrl = null;
  if (userData) {
    if (userType === 'parent' && userData.students?.[0]?.schools) {
      schoolLogoUrl = userData.students[0].schools.logo_url;
    } else if (userType === 'student' && userData.schools) {
      schoolLogoUrl = userData.schools.logo_url;
    // --- NUEVO: Añadir caso para maestro ---
    } else if (userType === 'teacher' && userData.schools) {
      schoolLogoUrl = userData.schools.logo_url;
    }
  }

  // --- NUEVA LÓGICA PARA MOSTRAR ROL ---
  let roleDisplayName = '';
  if (userType === 'parent') {
    roleDisplayName = 'Padre/Madre';
  } else if (userType === 'student') {
    roleDisplayName = 'Estudiante';
  } else if (userType === 'teacher') {
    // Muestra el rol específico (ej. 'Teaching Staff') de la tabla 'teachers'
    roleDisplayName = userData.role || 'Maestro'; 
  }
  // --- FIN NUEVA LÓGICA ---

  return (
    <header className="sticky top-0 bg-white border-b border-gray-200 z-30">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 -mb-px">
          {/* Botón para abrir/cerrar sidebar en móvil */}
          <div className="flex lg:hidden">
            <button
              ref={trigger} // Adjunta la ref al botón
              className="text-gray-500 hover:text-gray-600"
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              onClick={(e) => {
                e.stopPropagation();
                setSidebarOpen(!sidebarOpen);
              }}
            >
              <span className="sr-only">Open sidebar</span>
              <Menu size={24} />
            </button>
          </div>

          {/* Espaciador */}
          <div className="flex-grow"></div>

          {/* Info del Usuario y Logo del Colegio (MODIFICADO) */}
          <div className="flex items-center space-x-4">
            <div className="text-right">
                {/* Muestra el nombre (prioriza full_name si existe) */}
                <p className="font-semibold text-sm text-gray-800 truncate">
                    {userData?.full_name || userData?.first_name || user?.email}
                </p>
                {/* Muestra el rol determinado */}
                <p className="text-xs text-gray-500 capitalize">
                    {roleDisplayName} {/* <-- USA LA NUEVA VARIABLE */}
                </p>
            </div>
            
            {schoolLogoUrl && (
                <div className="w-10 h-10 flex items-center justify-center">
                    <img 
                        src={schoolLogoUrl} 
                        alt="Logo del Colegio" 
                        className="max-h-full max-w-full object-contain"
                    />
                </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;